import { createAction, props } from '@ngrx/store';
import { QuickEventWithDishes, QuickEvent, QuickEventToCreate, QuickEventToEdit } from '../../models/quick-event';

export enum QuickEventsActionTypes {
  LoadQuickEvent = 'Load Quick Event',
  LoadQuickEventSuccess = 'Load Quick Event Success',
  LoadQuickEventError = 'Load Quick Event Error',
  LoadUserQuickEvents = 'Load User Quick Events',
  LoadUserQuickEventsSuccess = 'Load User Quick Events Success',
  LoadUserQuickEventsError = 'Load User Quick Events Error',
  CreateQuickEvent = 'Create Quick Event',
  CreateQuickEventSuccess = 'Create Quick Event Success',
  CreateQuickEventError = 'Create Quick Event Error',
  UpdateQuickEvent = 'Update Quick Event',
  UpdateQuickEventSuccess = 'Update Quick Event Success',
  UpdateQuickEventError = 'Update Quick Event Error',
  DeleteQuickEvent = 'Delete Quick Event',
  DeleteQuickEventSuccess = 'Delete Quick Event Success',
  DeleteQuickEventError = 'Delete Quick Event Error',
  ClearQuickEvent = 'Clear Quick Event',
  ClearQuickEvents = 'Clear Quick Events',
  ClearAll = 'Clear All',
}

export const loadQuickEvent = createAction(
  QuickEventsActionTypes.LoadQuickEvent,
  props<{ quickEventId: string }>(),
);

export const loadQuickEventSuccess = createAction(
  QuickEventsActionTypes.LoadQuickEventSuccess,
  props<{ quickEvent: QuickEventWithDishes }>(),
);

export const loadQuickEventError = createAction(
  QuickEventsActionTypes.LoadQuickEventError,
  props<{ errorMessage: string }>(),
);

export const loadUserQuickEvents = createAction(
  QuickEventsActionTypes.LoadUserQuickEvents,
);

export const loadUserQuickEventsSuccess = createAction(
  QuickEventsActionTypes.LoadUserQuickEventsSuccess,
  props<{ quickEvents: QuickEvent[] }>(),
)

export const loadUserQuickEventsError = createAction(
  QuickEventsActionTypes.LoadUserQuickEventsError,
  props<{ errorMessage: string }>(),
)

export const createQuickEvent = createAction(
  QuickEventsActionTypes.CreateQuickEvent,
  props<{ quickEvent: QuickEventToCreate }>(),
);

export const createQuickEventSuccess = createAction(
  QuickEventsActionTypes.CreateQuickEventSuccess,
  props<{ quickEvent: QuickEventWithDishes }>(),
);

export const createQuickEventError = createAction(
  QuickEventsActionTypes.CreateQuickEventError,
  props<{ errorMessage: string }>(),
);

export const updateQuickEvent = createAction(
  QuickEventsActionTypes.UpdateQuickEvent,
  props<{ quickEventId: string, quickEvent: QuickEventToEdit }>(),
);

export const updateQuickEventSuccess = createAction(
  QuickEventsActionTypes.UpdateQuickEventSuccess,
  props<{ quickEvent: QuickEventWithDishes }>(),
);

export const updateQuickEventError = createAction(
  QuickEventsActionTypes.UpdateQuickEventError,
  props<{ errorMessage: string }>(),
);

export const deleteQuickEvent = createAction(
  QuickEventsActionTypes.DeleteQuickEvent,
  props<{ quickEventId: string }>(),
);

export const deleteQuickEventSuccess = createAction(
  QuickEventsActionTypes.DeleteQuickEventSuccess,
  props<{ quickEventId: string }>(),
);

export const deleteQuickEventError = createAction(
  QuickEventsActionTypes.DeleteQuickEventError,
  props<{ errorMessage: string }>(),
);

export const clearQuickEvent = createAction(
  QuickEventsActionTypes.ClearQuickEvent,
);

export const clearQuickEvents = createAction(
  QuickEventsActionTypes.ClearQuickEvents,
);

export const clearAll = createAction(
  QuickEventsActionTypes.ClearAll,
);
